import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

import { getIsProd } from "../config";

export type CallIntroStep = "CustomerInfoCollection" | "ProductCollection" | "IntroFlowCompleted";

const initialStep: CallIntroStep = "CustomerInfoCollection";

interface CallIntroProps {
    stepHistory: CallIntroStep[];
    currentStep: CallIntroStep;
    pushStep: (step: CallIntroStep) => void;
    popStep: () => void;
    resetSteps: () => void;
}

export const useCallIntroStore = createWithEqualityFn<CallIntroProps>()(
    persist(
        immer(
            devtools(
                (set) => ({
                    stepHistory: [initialStep],
                    currentStep: initialStep,
                    pushStep: (step: CallIntroStep) => {
                        set(
                            (state) => {
                                state.stepHistory.push(step);
                                state.currentStep = step;
                            },
                            false,
                            "pushStep",
                        );
                    },
                    popStep: () => {
                        set(
                            (state) => {
                                if (state.stepHistory.length > 1) {
                                    state.stepHistory.pop();
                                    state.currentStep = state.stepHistory[state.stepHistory.length - 1];
                                }
                            },
                            false,
                            "popStep",
                        );
                    },
                    resetSteps: () => {
                        set(
                            (state) => {
                                state.stepHistory = [initialStep];
                                state.currentStep = initialStep;
                            },
                            false,
                            "resetSteps",
                        );
                    },
                }),
                {
                    enabled: !getIsProd(),
                    store: "call-intro-flow-store",
                    name: "workspace/customer-panel",
                },
            ),
        ),
        { name: "call-intro-flow-store", skipHydration: true },
    ),
    shallow,
);
